export interface Normalize<T> {
  [key: string]: T;
}
